import { Card, CardHeader, Grid } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { Col, Result, Row, Statistic, Typography } from "antd";
import MDBox from "~/components/MDBox";
import DefaultProjectCard from "~/examples/Cards/ProjectCards/DefaultProjectCard";
// Material Dashboard 2 React base styles
import { useParams } from "react-router";
import PageLayout from "~/examples/LayoutContainers/PageLayout";
import { getPlantDetailsByQRapi } from "~/services/public.service";
import { getImageUrl } from "~/utils/utils";

import CardContent from "@mui/material/CardContent";
import Skeleton from "@mui/material/Skeleton";
import MDTypography from "~/components/MDTypography";

function LoadingSkeleton() {
  return (
    <Card sx={{ m: 2 }}>
      <Skeleton sx={{ height: 250 }} animation="wave" variant="rectangular" />
      <CardHeader
        // avatar={<Skeleton animation="wave" variant="circular" width={40} height={40} />}
        title={
          <Skeleton
            animation="wave"
            height={10}
            width="80%"
            style={{ marginBottom: 6 }}
          />
        }
        subheader={<Skeleton animation="wave" height={10} width="40%" />}
      />

      <CardContent>
        <Row gutter={16}>
          {Array.from({ length: 6 }).map((item) => (
            <Col key={item} span={12}>
              <Skeleton
                animation="wave"
                height={30}
                style={{ marginBottom: 6 }}
              />
            </Col>
          ))}
        </Row>
      </CardContent>
    </Card>
  );
}

const PlantDetails = () => {
  const params = useParams();

  const { Text } = Typography;
  const hasQrCode = params?.qrCode && typeof params.qrCode === "string";

  const { isLoading, isSuccess, error, isError, data } = useQuery({
    queryKey: [hasQrCode ? params.qrCode : null],
    queryFn: () => (hasQrCode ? getPlantDetailsByQRapi(params.qrCode) : null),
    enabled: hasQrCode,
  });

  function formatKeyToTitle(key) {
    // Split the key into words using underscores as separators
    const words = key.split("_");

    // Capitalize the first letter of each word
    const capitalizedWords = words.map(
      (word) => word.charAt(0).toUpperCase() + word.slice(1)
    );

    // Join the words back together with a space separator
    const title = capitalizedWords.join(" ");

    return title;
  }

  // Specify the fields you want to exclude
  const excludedFields = [
    "Plant_Img",
    "Plant_Desc",
    "Plant_Uses",
    "Plant_Scientific_Name",
    "Plant_Local_Name",
    "Plant_Color",
    "Plant_Color_Name"
  ];

  // Create a new object with formatted titles
  const formattedObject = {};
  for (const key in data?.data ?? {}) {
    // Check if the key is not in the excludedFields array
    if (!excludedFields.includes(key)) {
      const formattedKey = formatKeyToTitle(key);
      formattedObject[formattedKey] = data?.data[key];
    }
  }

  return (
    <PageLayout>
      <MDBox m={3} pt={2} pb={3}>
        <Grid container justifyContent="center" alignItems="center">
          {isSuccess &&
          Object.prototype.hasOwnProperty.call(params, "qrCode") ? (
            <Grid item xs={12} lg={6} md={6}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={0.5}
                  px={2}
                  variant="gradient"
                  bgColor="success"
                  borderRadius="lg"
                  coloredShadow="success"
                  color="white"
                >
                  <CardHeader title={"Plant Details"} />
                </MDBox>
                <MDBox pt={3}>
                  <DefaultProjectCard
                    image={getImageUrl(data?.data?.Plant_Img)}
                    label={
                      <MDTypography variant="subtitle" ml={2}>
                        {data?.data?.Plant_Scientific_Name}
                      </MDTypography>
                    }
                    title={
                      <MDTypography ml={2} variant="h5">
                        {data?.data?.Plant_Local_Name}
                      </MDTypography>
                    }
                    description={
                      <MDBox p={2}>
                        <Row gutter={16}>
                          {Object.entries(formattedObject).map(
                            ([key, value]) => (
                              <Col key={key} span={12}>
                                <Statistic
                                  title={
                                    <Text strong>
                                      {key === "Plant Eng Name"
                                        ? "Plant English Name"
                                        : key}
                                    </Text>
                                  }
                                  value={value}
                                />
                              </Col>
                            )
                          )}
                        </Row>
                        <Row gutter={16}>
                          <Col span={12}>
                            <Text strong>Plant Description</Text>
                            {" : "}
                            <Text italic>{data?.data["Plant_Desc"]}</Text>
                          </Col>
                          <Col span={12}>
                            <Text strong>Plant Uses</Text>
                            {" : "}
                            <Text italic>{data?.data["Plant_Uses"]}</Text>
                          </Col>
                        </Row>
                      </MDBox>
                    }
                    action={{
                      type: "external",
                      //   route: `/dashboard/location/plotting/plantation/plant/${item.Plant_Auto_ID}`,
                      color: "success",
                      label: "View Monitoring",
                    }}
                  />
                </MDBox>
              </Card>
            </Grid>
          ) : null}
          {isLoading ? (
            <Grid item xs={12} lg={6} md={6} justifySelf="end">
              <LoadingSkeleton />
            </Grid>
          ) : null}
        </Grid>
        {isError || !Object.prototype.hasOwnProperty.call(params, "qrCode") ? (
          <Result
            status="404"
            title="Error"
            subTitle="Sorry, content you're looking for not found."
            // extra={!mobileView ? <Button type="primary">Back Home</Button> : null}
          />
        ) : null}
      </MDBox>
    </PageLayout>
  );
};

export default PlantDetails;
